import {
  Button,
  Checkbox,
  Divider,
  Form,
  Icon,
  Input,
  Loading,
  Message,
} from '@alifd/next';
import { history } from 'ice';
import React, { useEffect, useState } from 'react';

import commonhelper from '@/lib/commonhelper';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';
import { useInterval } from './utils';

const { Item } = Form;
const DEFAULT_DATA = {
  email: '',
  password: '',
  // autoLogin: true,
  // phone: '',
  // code: '',
};

const LoginBlock = (
  props = {
    dataSource: DEFAULT_DATA,
  }
) => {
  // console.log("======= history.location.pathname", history.location.pathname)
  const { dataSource = DEFAULT_DATA } = props;

  const [username, setUsername] = useState('');
  const [postData, setValue] = useState(dataSource);

  const [isRunning, checkRunning] = useState(false);
  const [isPhone, checkPhone] = useState(false);
  const [second, setSecond] = useState(59);

  // const [isLoading, checkLoading] = useState({visible: true});
  const [isLoading, setIsLoading] = useState(false);

  function getQueryStringValue(key) {
    return decodeURIComponent(
      window.location.href.replace(
        new RegExp(
          `^(?:.*[&\\?]${encodeURIComponent(key).replace(
            /[\.\+\*]/g,
            '\\$&'
          )}(?:\\=([^&]*))?)?.*$`,
          'i'
        ),
        '$1'
      )
    );
  }

  // useEffect(() => {
  //   const isTouchable = Boolean(navigator.maxTouchPoints);
  //   if (isTouchable) window.location.href = '#/mobile/user/login';
  // }, []);

  useEffect(() => {
    // -如果url有帶query:account & password
    const UrlParsed = window.location.href.split('?').reverse();
    console.log('UrlParsed:', UrlParsed);
    if (
      // 只要有params，而且有帳號密碼
      UrlParsed.length > 1 &&
      UrlParsed[0].includes('account=') &&
      UrlParsed[0].includes('psd=')
    ) {
      setIsLoading(true);
      client
        .authenticate({
          strategy: 'local',
          email: getQueryStringValue('account'),
          password: getQueryStringValue('psd'),
        })
        .then((result) => {
          console.log(result);
          setIsLoading(false);
          if (
            result.user.auth === 'admin' &&
            getQueryStringValue('app') === '1'
          ) {
            setTimeout(
              (location.href =
                window.location.origin +
                '/admin/#/home?t=' +
                result.accessToken),
              3000
            );
          } else if (
            window.location.href.includes('/mobile/') ||
            getQueryStringValue('app') === '1'
          ) {
            history.push('/mobile/home');
          } else {
            history.push('/ezpro/home');
          }
        })
        .catch((error) => {
          const isTouchable = Boolean(navigator.maxTouchPoints);
          if (isTouchable) window.location.href = '#/mobile/user/login';
          setIsLoading(false);
          console.log('==direct login error:', error);
        });
    } else if (UrlParsed.length > 1 && UrlParsed[0].includes('e=')) {
      // QRcode驗證+註冊帳號
      // if(UrlParsed[0].includes('acc=') && UrlParsed[0].includes('psd=')){
      //   window.location = '/ezcon/api/codeVerfiAndRegisterNewOne?' + UrlParsed[0];
      // }
      if (!UrlParsed[0].includes('acc=') && !UrlParsed[0].includes('psd=')) {
        // decode Base64 and lonin

        const accountAndPassword = atob(getQueryStringValue('e'))
          .split('&')
          .map((i) => i.slice(i.indexOf('=') + 1, i.length));
        if (accountAndPassword.length < 2) return;
        setIsLoading(true);
        console.log(
          'account:',
          accountAndPassword[0],
          'password:',
          accountAndPassword[1]
        );
        client
          .authenticate({
            strategy: 'local',
            email: accountAndPassword[0],
            password: accountAndPassword[1],
          })
          .then((result) => {
            console.log(result);
            setIsLoading(false);
            if (
              window.location.href.includes('/mobile/') ||
              getQueryStringValue('app') === '1'
            ) {
              history.push('/mobile/home');
            } else {
              // history.push('/ezpro/home');
            }
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('==direct login error:', error);
            if (commonhelper.isApp()) {
              commonhelper.loadPath('/addCom');
            }
            const isTouchable = Boolean(navigator.maxTouchPoints);
            if (isTouchable) window.location.href = '#/mobile/user/login';
          });
      }
    } else {
      // sessionStorage裡面有feathers-jwt
      client
        .reAuthenticate()
        .then((data) => {
          console.log('==relogin ok', data.user.email);
          setUsername(data.user.email);
          setIsLoading(false);
          if (
            window.location.href.includes('/mobile/') ||
            getQueryStringValue('app') === '1'
          ) {
            history.push('/mobile/home');
          } else {
            history.push('/ezpro/home');
          }
        })
        .catch((err) => {
          setIsLoading(false);

          console.log('==relogin fail');
        });
    }
  }, []);

  useInterval(
    () => {
      setSecond(second - 1);

      if (second <= 0) {
        checkRunning(false);
        setSecond(59);
      }
    },
    isRunning ? 1000 : null
  );

  const formChange = (values) => {
    setValue(values);
  };

  const sendCode = (values, errors) => {
    if (errors) {
      return;
    } // get values.phone

    checkRunning(true);
  };

  const handleSubmit = (values, errors) => {
    if (errors) {
      console.log('errors', errors);
      return;
    }
    console.log('values:', values);
    client
      .authenticate({
        strategy: 'local',
        email: values.email,
        password: values.password,
      })
      .then((result) => {
        console.log('result:', result);
        Message.success('登入成功');

        setTimeout(() => {
          if (history.location.pathname === '/mobile/user/login') {
            history.push('/mobile/home');
          } else {
            history.push('/ezpro/home');
          }
        }, 1000);
      })
      .catch((err) => {
        console.log('auth error:', err);
        Message.error('登入失敗');
      });
  };

  const phoneForm = (
    <>
      {/* <Item format="tel" required requiredMessage="必填" asterisk={false}>
        <Input
          name="phone"
          innerBefore={
            <span className={styles.innerBeforeInput}>
              +86
              <span className={styles.line} />
            </span>
          }
          maxLength={20}
          placeholder="手机号"
        />
      </Item>
      <Item
        required
        requiredMessage="必填"
        style={{
          marginBottom: 0,
        }}
      >
        <Input
          name="code"
          innerAfter={
            <span className={styles.innerAfterInput}>
              <span className={styles.line} />
              <Form.Submit
                text
                type="primary"
                style={{
                  width: 64,
                }}
                disabled={!!isRunning}
                validate={['phone']}
                onClick={sendCode}
                className={styles.sendCode}
              >
                {isRunning ? ${second}秒后再试 : '获取验证码'}
              </Form.Submit>
            </span>
          }
          maxLength={20}
          placeholder="验证码"
        />
      </Item> */}
    </>
  );
  const accountForm = (
    <>
      <Item required requiredMessage="必填">
        <Input name="email" maxLength={50} placeholder="信箱" />
      </Item>
      <Item
        required
        requiredMessage="必填"
        style={{
          marginBottom: 0,
        }}
      >
        <Input.Password
          name="password"
          htmlType="password"
          placeholder="密碼"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSubmit(postData);
            }
          }}
        />
      </Item>
      <div style={{ height: '20px' }} />
    </>
  );

  const byAccount = () => {
    checkPhone(false);
  };

  const appLogin = () => {
    history.push('/mobile/user/login');
  };
  const byForm = () => {
    checkPhone(true);
  };

  // 偵測裝置導向app商店
  const handleRedirectToStore = () => {
    if (navigator.userAgent.match('Android'))
      window.location.href =
        'https://play.google.com/store/apps/details?id=tw.com.ezcon.ezpro';
    if (navigator.userAgent.match('iPhone'))
      window.location.href =
        'https://apps.apple.com/tw/app/ez%E7%A4%BE%E5%8D%80/id1563361625';
  };

  const isUsingMobilePath = history.location.pathname === '/mobile/user/login';

  const MobileLoginBlock = (
    <div className={styles.mobileLogin}>
      <div className={styles.mobileVoteBackground} />

      <div className={styles.mobileLoginContainer}>
        <div className={styles.mobileAccountText}>帳號登入</div>
        {/* <div className={styles.desc}>
              <span onClick={byAccount} className={isPhone ? undefined : styles.active}>
                帳號登入
          </span>

            </div> */}

        <Form value={postData} onChange={formChange} size="large">
          {isPhone ? phoneForm : accountForm}

          <Item
            style={{
              marginBottom: 10,
            }}
          >
            <Form.Submit
              type="primary"
              onClick={handleSubmit}
              className={styles.mobileSubmitBtn}
              validate
            >
              登入
            </Form.Submit>
            <Button
              type="primary"
              className={styles.mobileSubmitBtn}
              onClick={handleRedirectToStore}
            >
              下載App
            </Button>
          </Item>
          <div className={styles.mobileLinkBox}>
            {/* <div className={styles.mobilePsd}>
                  <a onClick={() => {
                    if (history.location.pathname === `/mobile/user/login`) {
                      history.push('/mobile/user/resetPasswordVerify');
                    } else {
                      history.push('/user/resetPasswordVerify')
                    }

                  }
                  } className={styles.mobileLink}>
                    忘記密碼
              </a>
                </div> */}

            <div>
              <a
                onClick={() => {
                  if (history.location.pathname === '/mobile/user/login') {
                    history.push('/mobile/user/register');
                  } else {
                    history.push('/user/register');
                  }
                }}
                className={styles.mobileLink}
              >
                註冊帳號
              </a>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
  const DesktopLoginBlock = (
    <div className={styles.LoginBlock}>
      <div className={styles.innerBlock}>
        {/* <a href="#">
          <img
            className={styles.logo}
            src="https://img.alicdn.com/tfs/TB1KtN6mKH2gK0jSZJnXXaT1FXa-1014-200.png"
            alt="logo"
          />
        </a> */}
        <div className={styles.desc}>
          <span
            onClick={byAccount}
            className={isPhone ? undefined : styles.active}
          >
            帳號登入
          </span>
          <span
            onClick={appLogin}
            className={isPhone ? undefined : styles.link}
          >
            APP登入
          </span>
          {/* <Divider direction="ver" /> */}
          {/* <span onClick={byForm} className={isPhone ? styles.active : undefined}>
            手机号登录
          </span> */}
        </div>

        <Form value={postData} onChange={formChange} size="large">
          {isPhone ? phoneForm : accountForm}
          {/* phoneForm */}

          <div className={styles.infoLine}>
            <Item
              style={{
                marginBottom: 0,
              }}
            >
              {/* <Checkbox name="autoLogin" className={styles.infoLeft}>
                自動登入
              </Checkbox> */}
            </Item>
          </div>

          <Item
            style={{
              marginBottom: 10,
            }}
          >
            <Form.Submit
              type="primary"
              onClick={handleSubmit}
              className={styles.submitBtn}
              validate
            >
              登入
            </Form.Submit>
          </Item>
          <div className={styles.infoLine}>
            {/* <div className={styles.infoLeft}>
              其他方式登入 <Icon type="atm" size="small" /> <Icon type="atm" size="small" />{' '}
              <Icon type="atm" size="small" />
            </div> */}
            <div style={{ height: '10px' }} />

            {/* <a onClick={() => {
                    if (history.location.pathname === `/mobile/user/login`) {
                      history.push('/mobile/user/resetPasswordVerify');
                    } else {
                      history.push('/user/resetPasswordVerify')
                    }

                  }
                  } className={styles.link} style={{marginRight:"10px"}}>
                    忘記密碼
              </a> */}

            <a
              onClick={() => {
                if (history.location.pathname === '/mobile/user/login') {
                  history.push('/mobile/user/register');
                } else {
                  history.push('/user/register');
                }
              }}
              className={styles.link}
            >
              註冊帳號
            </a>
          </div>
        </Form>
      </div>
    </div>
  );

  return (
    <>
      {isUsingMobilePath && MobileLoginBlock}
      {!isUsingMobilePath && DesktopLoginBlock}

      <Loading visible={isLoading} fullScreen shape="fusion-reactor" />
    </>
  );
};

export default LoginBlock;
